<template>
  <div class="ai rt60">
    <div>
      <!-- <banner :child-data="fdata"></banner> -->
      <div style="height:650px;overflow:hidden"
           class="mainTop"
           :style="{ height: Mobile + 'px'}">
        <img v-if="!showMobile"
             src="img/Ai/人脸识别.jpg"
             alt=""
             class="mobile"
             style="height:100%;position: relative;"
             :style="{ height: Mobile + 'px'}">
        <img v-if="showMobile"
             src="img/Ai/Fmobile.jpg"
             alt=""
             class="mobile"
             style="position: relative;"
             :style="{ height: Mobile + 'px'}">
      </div>
      <div id="ai-main">
        <div>
          <div class="ai-sec container"
               data-ani>
            <div class="develop-title">
              <span class="line"></span>
              <span class="title-text">{{$t('Function')}}</span>
              <span class="line"></span>
            </div>
            <b-button-group>
              <b-button @click="addActive('face')"
                        :class="menu=='face'?'active':''"
                        variant="outline-primary">{{$t('homenavFT0')}}</b-button>
              <b-button @click="addActive('eigenvalues')"
                        :class="menu=='eigenvalues'?'active':''"
                        variant="outline-primary">{{$t('homenavFT7')}}</b-button>
              <b-button @click="addActive('multiface')"
                        :class="menu=='multiface'?'active':''"
                        variant="outline-primary">{{$t('homenavFT1')}}</b-button>
              <b-button @click="addActive('faceattribute')"
                        :class="menu=='faceattribute'?'active':''"
                        variant="outline-primary">{{$t('homenavFT2')}}</b-button>
              <b-button @click="addActive('facekeyframe')"
                        :class="menu=='facekeyframe'?'active':''"
                        variant="outline-primary">{{$t('homenavFT8')}}</b-button>
              <b-button @click="addActive('location')"
                        :class="menu=='location'?'active':''"
                        variant="outline-primary">{{$t('homenavFT3')}}</b-button>
              <b-button @click="addActive('recognition')"
                        :class="menu=='recognition'?'active':''"
                        variant="outline-primary">{{$t('homenavFT4')}}</b-button>
              <!-- <b-button
                @click="addActive('vertification')"
                :class="menu=='vertification'?'active':''"
                variant="outline-primary"
              >{{$t('homenavFT5')}}</b-button> -->
              <!-- <b-button @click="addActive('antispoofing')"
                        :class="menu=='antispoofing'?'active':''"
                        variant="outline-primary">{{$t('homenavFT6')}}</b-button> -->
            </b-button-group>
            <!-- 人脸检测与分析 -->
            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="faceimg0"
                   class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img
                   class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img class="m1h1"
                   ref="deeiimg0"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,8)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="mofaceimg0"
                   class="m1h1"
                   @click="getFile($event,1)"
                   src="../../public/img/Ai/example/multiface.jpg"
                   alt />
            </div>

            <!-- 人脸检测与分析 -->
            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img
                   class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   ref="defimg0"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img
                   class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   ref="locimg1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img
                   class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   ref="locimg0"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,4)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="defimg1"
                   class="m1h1"
                   @click="getFile($event,5)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img ref="defimg2"
                   class="m1h1"
                   @click="getFile($event,6)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,5)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,6)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,5)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,6)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,5)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <!-- <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="mofaceimg10"
                   class="m1h1"
                   @click="getFile($event,10)"
                   src="../../public/img/Ai/example/alive.jpg"
                   alt />
            </div> -->

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="witness1"
                   class="m1h1"
                   @click="getFile($event,7)"
                   src="../../public/img/Ai/example/f-1.jpg"
                   alt />
              <img ref="witness2"
                   class="m1h1"
                   @click="getFile($event,9)"
                   src="../../public/img/Ai/example/f-3.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,7)"
                   src="../../public/img/Ai/example/f-5.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,9)"
                   src="../../public/img/Ai/example/f-6.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,7)"
                   src="../../public/img/Ai/example/f-8.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,9)"
                   src="../../public/img/Ai/example/f-11.jpg"
                   alt />
              <img class="m1h1"
                   @click="getFile($event,7)"
                   src="../../public/img/Ai/example/f-13.jpg"
                   alt />
            </div>

            <div class="fileGroup"
                 v-show="menu=='face'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec"
                      ref="myli">
                    <div :class="{imgline: pictLoading}"></div>
                    <img ref="myimg"
                         :src="img0" />
                    <canvas ref="mycanvas"
                            :width="canvasWidth"
                            :height="canvasHeight"
                            class="mycanvas"></canvas>
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(0)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,0)"
                         ref="inputer0"
                         id="file0"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg0}}</pre>
                </div>
              </div>
            </div>

            <div class="fileGroup"
                 v-show="menu=='eigenvalues'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img8" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(8)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,8)"
                         ref="inputer8"
                         id="file8"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg8}}</pre>
                </div>
              </div>
            </div>

            <div class="fileGroup"
                 v-show="menu=='multiface'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img1" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(1)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         src="../"
                         @change="addImg($event,1)"
                         ref="inputer1"
                         id="file1"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg1}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='faceattribute'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img2" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(2)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,2)"
                         ref="inputer2"
                         id="file2"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg2}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='facekeyframe'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img3" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(3)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,3)"
                         ref="inputer3"
                         id="file3"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg3}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='location'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img4" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(4)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,4)"
                         ref="inputer4"
                         id="file4"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg4}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='recognition'"
                 style="position:relative">
              <div class="imgLeft">
                <div class="tips">对比图片1</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img5" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(5)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,5)"
                         ref="inputer5"
                         id="file5"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="imgLeft">
                <div class="tips">对比图片2</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img6" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(6)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,6)"
                         ref="inputer6"
                         id="file6"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>

              <div class="responseTips specialTips"
                   style="position: absolute;
                    background: white;
                    width: 150px;
                    height: 150px;
                    border-radius: 50%;
                    top: 80px;
                    padding: 10px 10px 10px;
                    line-height: 130px;
                    text-align: center;
                    border: 2px dashed skyblue;"
                   v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)">
                <p style="color:red;text-align:center">{{msgcompare}}</p>
              </div>

            </div>
            <div class="bottomBtn"
                 v-show="menu=='recognition'">
              <b-button variant="success"
                        class="compare"
                        @click="compare()">人脸比对</b-button>
            </div>
            <!-- <div class="fileGroup"
                 v-show="menu=='antispoofing'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img10" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(10)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         src="../"
                         ref="inputer10"
                         id="file10"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right" v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg10}}</pre>
                </div>
              </div>
            </div> -->
            <!-- <div class="fileGroup" v-show="menu=='vertification'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <img :src="img7" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary" @click="triggerFile(7)">本地上传</b-button>
                  <input
                    type="file"
                    class="upload"
                    @change="addImg($event,7)"
                    ref="inputer7"
                    id="file7"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                  />
                </div>
              </div>
              <div class="json_right">
                <div class="tips">搜索结果</div>
              </div>
            </div> -->
            <!-- <div class="fileGroup" v-show="menu=='vertification'" style="position:relative">
              <div class="imgLeft">
                <div class="tips">人脸图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <img :src="img7" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary" @click="triggerFile(7)">本地上传</b-button>
                  <input
                    type="file"
                    class="upload"
                    @change="addImg($event,7)"
                    ref="inputer7"
                    id="file7"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                  />
                </div>
              </div>
              <div class="imgLeft">
                <div class="tips">身份证图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <img :src="img9" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary" @click="triggerFile(9)">本地上传</b-button>
                  <input
                    type="file"
                    class="upload"
                    @change="addImg($event,9)"
                    ref="inputer9"
                    id="file9"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                  />
                </div>
              </div>

              <div class="responseTips specialTips" style="position: absolute;
                background: white;
                width: 150px;
                border-radius: 50%;
                border: 1px solid red;
                top: 100px;
                padding:10px;
                padding-top:28px" >
                <p style="color:red;text-align:center">{{msgcompare2}}</p>
              </div>

            </div> -->
            <!-- <div class="bottomBtn" v-show="menu=='vertification'">
              <b-button variant="success" class="compare" @click="compare2()">人证对比</b-button>
            </div> -->
          </div>
          <div class="ai-advantage"
               data-ani>
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">{{$t('Feature')}}</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon icon0"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT0')}}</h4>
                    <p>{{$t('AFeatureTP0')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon1"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT1')}}</h4>
                    <p>{{$t('AFeatureTP1')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon2"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT2')}}</h4>
                    <p>{{$t('AFeatureTP2')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon icon3"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT3')}}</h4>
                    <p>{{$t('AFeatureTP3')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon4"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT4')}}</h4>
                    <p>{{$t('AFeatureTP4')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon5"></i>
                  <b-card-text>
                    <h4>{{$t('AFeatureT5')}}</h4>
                    <p>{{$t('AFeatureTP5')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>
          <div class="ai-scene"
               data-ani>
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">{{$t('Scenario')}}</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="Card image myleftIcon icon0"></i>
                  <b-card-text>
                    <h4>{{$t('AScenarioT0')}}</h4>
                    <p>{{$t('AScenarioTP0')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon icon1"></i>
                  <b-card-text>
                    <h4>{{$t('AScenarioT1')}}</h4>
                    <p>{{$t('AScenarioTP1')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon icon2"></i>
                  <b-card-text>
                    <h4>{{$t('AScenarioT2')}}</h4>
                    <p>{{$t('AScenarioTP2')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'
import Axios from 'axios'
export default {
  name: 'about',
  data() {
    return {
      fdata: {
        h1: 'homenavFT',
        h2:
          '腾讯人脸识别基于腾讯优图和腾讯AI Lab的深度学习算法和海量数据集，对图片和视频源中面部特征进行提取分析。可实现精准的人脸检测和人脸识别，涵盖人脸检测与分析、五官定位、人脸对比与搜索、跨年龄人脸识别等，为安防监控、人脸美化、智能相册分类等应用场景提供有力的技术支持。',
        style: {
          background: '#0052d9'
        },
        myheaderstyle: {
          display: 'flex',
          'justify-content': 'space-around'
        },
        imgurl: '../../img/Ai/人脸识别.jpg'
      },
      formData: new FormData(),
      pictLoading: true,
      customcxt: '',
      canvasWidth: '',
      oldimgHeight: '',
      screenWidth: document.body.clientWidth,
      showMobile: false,
      Mobile: 650,
      img0: '',
      img1: {},
      img2: {},
      img3: {},
      img4: {},
      img5: {},
      img6: {},
      img7: {},
      img8: {},
      img9: {},
      menu: 'face',
      fil: '',
      imgLen: 0,
      msg0: '',
      msg1: '',
      msg2: '',
      msg3: '',
      msg4: '',
      msg5: '',
      msg6: '',
      msg7: '',
      msg8: '',
      msgcompare: '',
      msgcompare2: '',
      com1: '',
      com2: '',
      com3: '',
      com4: ''
    }
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    addActive(val) {
      this.menu = val
        switch (val) {
            case 'face':
              this.$refs.faceimg0.click();
            break;
            case 'eigenvalues':
              this.$refs.deeiimg0.click();
            break;
            case 'multiface':
              this.$refs.mofaceimg0.click();
            break;
            case 'faceattribute':
              this.$refs.defimg0.click();
            break;
            case 'facekeyframe':
              this.$refs.locimg1.click();
            break;
            case 'location':
              this.$refs.locimg0.click();
            break;
            case 'recognition':
              this.$refs.defimg1.click()
              this.$refs.defimg2.click()
            break;
        }
    },
    show() {
      this.canvasWidth = this.$refs.myli.offsetWidth
      this.canvasHeight = this.$refs.myli.offsetHeight
      this.$nextTick(() => {
        const customCanvas = this.$refs.mycanvas // canvas显示层
        this.customcxt = customCanvas.getContext('2d')
        this.customcxt.strokeStyle = 'red'
        this.customcxt.lineWidth = 1
        // this.customcxt.fillRect(0, 0, 200, 200)
        var that = this
        var img = this.$refs.myimg
        // img.onload = function() {
        //   var imgWidth = this.naturalWidth
        //   var imgHeight = this.naturalHeight
        //   console.log(imgWidth, imgHeight)
        //   that.customcxt.strokeRect(
        //     343.48 / (that.canvasWidth / imgWidth),
        //     96.13 / 1.6,
        //     102 / 1.6,
        //     140 / 1.6
        //   )
        // }
        console.log(window.naturalWidth)
      })
    },
    formatJson(json, options) {
      var reg = null,
        formatted = '',
        pad = 0,
        PADDING = '    ' // one can also use '\t' or a different number of spaces
      // optional settings
      options = options || {}
      // remove newline where '{' or '[' follows ':'
      options.newlineAfterColonIfBeforeBraceOrBracket =
        options.newlineAfterColonIfBeforeBraceOrBracket === true ? true : false
      // use a space after a colon
      options.spaceAfterColon = options.spaceAfterColon === false ? false : true

      // begin formatting...

      // make sure we start with the JSON as a string
      if (typeof json !== 'string') {
        json = JSON.stringify(json)
      }
      // parse and stringify in order to remove extra whitespace
      json = JSON.parse(json)
      json = JSON.stringify(json)

      // add newline before and after curly braces
      reg = /([\{\}])/g
      json = json.replace(reg, '\r\n$1\r\n')

      // add newline before and after square brackets
      reg = /([\[\]])/g
      json = json.replace(reg, '\r\n$1\r\n')

      // add newline after comma
      reg = /(\,)/g
      json = json.replace(reg, '$1\r\n')

      // remove multiple newlines
      reg = /(\r\n\r\n)/g
      json = json.replace(reg, '\r\n')

      // remove newlines before commas
      reg = /\r\n\,/g
      json = json.replace(reg, ',')

      // optional formatting...
      if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
        reg = /\:\r\n\{/g
        json = json.replace(reg, ':{')
        reg = /\:\r\n\[/g
        json = json.replace(reg, ':[')
      }
      if (options.spaceAfterColon) {
        reg = /\:/g
        json = json.replace(reg, ': ')
      }

      $.each(json.split('\r\n'), function(index, node) {
        var i = 0,
          indent = 0,
          padding = ''

        if (node.match(/\{$/) || node.match(/\[$/)) {
          indent = 1
        } else if (node.match(/\}/) || node.match(/\]/)) {
          if (pad !== 0) {
            pad -= 1
          }
        } else {
          indent = 0
        }

        for (i = 0; i < pad; i++) {
          padding += PADDING
        }

        formatted += padding + node + '\r\n'
        pad += indent
      })
      //   this.pictLoading = false
      return formatted
    },
    getResult(url, formdata, ele, type, num, formdata2) {
      this.pictLoading = true
      this[ele] = ''
      let res1 = new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url,
          data: this.$qs.stringify(formdata)
        })
          .then(res => {
            resolve(res)
          })
          .catch(rej => {
            reject(rej)
          })
      })
      let res2 = new Promise((resolve, reject) => {
        formdata.ret = 'image'
        Axios({
          method: 'post',
          url,
          responseType: 'arraybuffer',
          data: this.$qs.stringify(formdata2)
        })
          .then(res => {
            resolve(res)
          })
          .catch(rej => {
            reject(rej)
          })
      })
      Promise.all([res1, res2]).then(res => {
        this.pictLoading = false
        //   res.for
        if (ele == 'msgcompare' || ele == 'msgcompare2') {
          this[ele] = '相似度: ' + (res[0].data.data * 100).toFixed(2) + '%'
          this.pictLoading = false
        } else {
          this[ele] = this.formatJson(res[0].data)
        }
        this['img' + num] =
          'data:image/png;base64,' +
          btoa(
            new Uint8Array(res[1].data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
          )
      })
      // console.log(this.$refs.myimg.offsetWidth)
    },
    triggerFile(val) {
      var myfile = document.getElementById('file' + val)
      myfile.click()
    },
    compare(val, img) {
      //   console.log(val, img)
      if (val != 5 && val != 6) {
        var baseUrl = this.img5.length > 100 ? this.img5 : this.com1
        if (baseUrl.split(',')[0].indexOf('base64') >= 0) {
          baseUrl = baseUrl.split(',')[1]
        }
        var baseUrl2 = this.img6.length > 100 ? this.img6 : this.com2
        if (baseUrl2.split(',')[0].indexOf('base64') >= 0) {
          baseUrl2 = baseUrl2.split(',')[1]
        }
        this.getResult(
          'https://ai.neuapi.com/v1/face_similarity',
          { image_type: 'BASE64', image_a: baseUrl, image_b: baseUrl2 },
          'msgcompare'
        )
      } else {
        // console.log(this.com1, this.com2)
        if (this.com1.length > 100 && this.com2.length > 100) {
          this.getResult(
            'https://ai.neuapi.com/v1/face_similarity',
            { image_type: 'BASE64', image_a: this.com1, image_b: this.com2 },
            'msgcompare'
          )
        }
      }
    },
    compare2(val, img) {
      console.log(val, img)
      if (val != 7 && val != 9) {
        var baseUrl = this.img7.length > 100 ? this.img7 : this.com3
        if (baseUrl.split(',')[0].indexOf('base64') >= 0) {
          baseUrl = baseUrl.split(',')[1]
        }
        var baseUrl2 = this.img9.length > 100 ? this.img9 : this.com4
        if (baseUrl2.split(',')[0].indexOf('base64') >= 0) {
          baseUrl2 = baseUrl2.split(',')[1]
        }
        this.getResult(
          'https://ai.neuapi.com/v1/face_similarity',
          { image_type: 'BASE64', image_a: baseUrl, image_b: baseUrl2 },
          'msgcompare2'
        )
      } else {
        console.log(this.com3, this.com4)
        if (this.com3.length > 100 && this.com4.length > 100) {
          this.getResult(
            'https://ai.neuapi.com/v1/face_similarity',
            { image_type: 'BASE64', image_a: this.com3, image_b: this.com4 },
            'msgcompare2'
          )
        }
      }
    },
    getFile(event, val) {
      console.log(event.target.src)
      var image = new Image()
      console.log(image)
      this['img' + val] = event.target.src
      image.crossOrigin = ''
      image.src = event.target.src
      var that = this
      image.onload = function() {
        that.oldimgHeight = 300 / image.height
        var base64 = that.getBase64Image(image)
        if (base64.split(',')[0].indexOf('base64') >= 0) {
          document.getElementById('file' + val).value = ''
          base64 = base64.split(',')[1]
          if (val == 0) {
            that.getResult(
              // https://ai.neuapi.com/ai/
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg0',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          } else if (val == 1) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg1',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          } else if (val == 2) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_attribute',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg2',
              'face_attribute',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          } else if (val == 3) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_landmarks',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg3',
              'face_landmarks',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          } else if (val == 4) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_landmark',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg4',
              'face_landmark',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          } else if (val == 5) {
            that.com1 = base64
            that.compare(5)
          } else if (val == 6) {
            that.com2 = base64
            that.compare(6)
          } else if (val == 7) {
            that.com3 = base64
            that.compare2(7)
          } else if (val == 9) {
            that.com4 = base64
            that.compare2(9)
          } else if (val == 8) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_feature',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg8'
            )
          } else if (val == 10) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_feature',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg10'
            )
          }
        }
      }
    },
    getBase64Image(img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      var dataURL = canvas.toDataURL('image/' + ext)
      return dataURL
    },
    addImg(event, val) {
      console.log(event.target.files[0])
      var inputDOM = event.target.files[0]
      var reader = new FileReader()
      var that = this
      reader.readAsDataURL(inputDOM)
      reader.onload = function(e) {
        that['img' + val] = this.result
        console.log(that['img' + val])
        let img = new Image()
        img.src = this.result
        var otherthat = that
        img.onload = function() {
          otherthat.oldimgHeight = 300 / img.height
        }
        var baseUrl = this.result
        if (baseUrl.split(',')[0].indexOf('base64') >= 0) {
          baseUrl = baseUrl.split(',')[1]
          if (val == 0) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg0',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 1) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg1',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 3) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_landmark',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg3',
              'face_landmark',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 2) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_attribute',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg2',
              'face_attribute',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 8) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_feature',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg8'
            )
          } else if (val == 10) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_feature',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg10'
            )
          }
        }
      }
    },
    ...mapMutations(['editMenu'])
  },
  mounted() {
    if (this.screenWidth < 480 || this.screenWidth === 480) {
      this.showMobile = true
      this.Mobile = window.screen.height
    }
    this.show()
    this.editMenu('about')
    this.$refs.faceimg0.click()
    // this.$refs.deeiimg0.click()
    // this.$refs.defimg1.click()
    // this.$refs.defimg2.click()
    // this.$refs.faceimg0.click()
    // this.$refs.mofaceimg0.click()
    // this.$refs.locimg0.click()
    // this.$refs.locimg1.click()
    // this.$refs.witness1.click()
    // this.$refs.witness2.click()
  },
  watch: {
    $route(to, from) {
      if (to.query.id) {
        this.menu = to.query.id
        switch (to.query.id) {
            case 'face':
              this.$refs.faceimg0.click();
            break;
            case 'eigenvalues':
              this.$refs.deeiimg0.click();
            break;
            case 'multiface':
              this.$refs.mofaceimg0.click();
            break;
            case 'faceattribute':
              this.$refs.defimg0.click();
            break;
            case 'facekeyframe':
              this.$refs.locimg1.click();
            break;
            case 'location':
              this.$refs.locimg0.click();
            break;
            case 'recognition':
              this.$refs.defimg1.click()
              this.$refs.defimg2.click()
            break;
        }
      } else {
        this.menu = 'face'
        this.$refs.faceimg0.click()
      }
    }
  }
}
</script>

<style scoped>
.m1h1 {
  /* width: 100px; */
  height: 100px;
}
.myicon {
  width: 80px;
  height: 80px;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 56px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.ai-advantage {
  background: rgb(245, 245, 245);
  padding: 60px 0px 60px;
}
.ai-advantage .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
}
.ai-advantage .card-body .myicon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: 0 -256px;*/
  margin-bottom: 20px;
}

.ai-advantage .card-body .myicon.icon0 {
  background-image: url(../../public/img/Ai/face/data.png);
}
.ai-advantage .card-body .myicon.icon1 {
  background-image: url(../../public/img/Ai/face/rate.png);
}
.ai-advantage .card-body .myicon.icon2 {
  background-image: url(../../public/img/Ai/face/improve.png);
}
.ai-advantage .card-body .myicon.icon3 {
  background-image: url(../../public/img/Ai/face/attribute.png);
}
.ai-advantage .card-body .myicon.icon4 {
  background-image: url(../../public/img/Ai/face/anti.png);
}
.ai-advantage .card-body .myicon.icon5 {
  background-image: url(../../public/img/Ai/face/rotate.png);
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text p {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px 0;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-scene .card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}
.ai-advantage .card .card-body h4 {
  text-align: center;
}
.ai-scene .card .card-body .card-text {
  flex: 1;
}
.ai-scene .card .card-body .card-text h4 {
  font-size: 18px;
}
.ai-scene .card .card-body .card-text p {
  font-size: 14px;
}
.ai-scene .card .card-body .myleftIcon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: -269px -340px; */
  width: 56px;
  height: 56px;
  display: block;
  margin-right: 20px;
}
.ai-scene .card .card-body .myleftIcon.icon0 {
  background-image: url(../../public/img/Ai/face/access.png);
}
.ai-scene .card .card-body .myleftIcon.icon1 {
  background-image: url(../../public/img/Ai/face/verification.png);
}
.ai-scene .card .card-body .myleftIcon.icon2 {
  background-image: url(../../public/img/Ai/face/mask.png);
}

.ai-scene .card img {
  width: 50%;
}

.ai-parter {
  background: rgb(245, 245, 245);
  padding: 60px 0;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec .col-6 {
  margin-bottom: 20px;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
}
.partner-sec .container {
  padding: 10px;
  width: 100%;
  background-color: white;
  border-radius: 6px;
}
.partner-sec img {
  width: 80%;
}
.ai-parter .develop-title .title-text {
  color: #2c3e50;
}
.ai-sec {
  padding: 60px 0px 60px;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  height: 350px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  width: 48%;
  position: relative;
}
@media screen and (max-width: 480px) {
  .fileGroup {
    flex-wrap: wrap;
    height: auto;
  }
  .fileGroup > div {
    width: 100%;
    position: relative;
  }
  .json_right {
    height: 300px;
    overflow-y: scroll;
  }
}

.fileGroup .json_right {
  border: 1px solid lightgray;
  height: 300px;
  overflow-y: scroll;
}

.fileGroup .imgShow {
  width: 100%;
  height: 300px;
  border: 1px solid lightgray;
  position: relative;
}
.fileGroup .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.fileGroup .json_right {
  background: aliceblue;
}
#file0,
#file1,
#file2,
#file3,
#file4,
#file5,
#file6,
#file7,
#file8,
#file9,
#file10 {
  display: none;
}
.fileGroup .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
  z-index: 10;
}
.btn-group {
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.imgShow .imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
  position: relative;
}
.compare {
  width: 20%;
  margin-top: 30px;
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.responseTips {
  padding-top: 30px;
  text-align: left;
  padding-left: 20px;
  word-break: break-all;
}
@media screen and (max-width: 1366px) {
  .mainTop {
    height: 440px;
  }
}
@media screen and (max-width: 480px) {
  /* .mainTop {
    height: 650px !important;
  } */
  .specialTips {
    top: 260px !important;
  }
  .mobile {
    width: auto !important;
    /* height: 100% !important; */
  }
}
.imgGroup {
  margin-bottom: 20px;
}
.imgGroup img {
  cursor: pointer;
}
.mycanvas {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: 10;
}
.imgline {
  position: absolute;
  height: calc(100% - 2px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #03a9f4 211%);
  border-bottom: 2px solid #03a9f4;
  transform: translateY(-100%);
  animation: radar-beam 1.5s infinite;
  animation-timing-function: cubic-bezier(0.3, 0, 0.43, 0.7);
  animation-delay: 0s;
  z-index: 11;
}
@keyframes radar-beam {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
